import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from './services/user.service';
import { User } from './services/user.model';

declare var $: any;

@Component({
  selector: 'wm-header-user-block',
  template: require('./user-block.component.html')
})
export class UserBlockComponent implements OnInit, AfterViewInit {
  currentUser: User;
  serviceRid: string;
  serviceLogin: string;
  currentUrl: string;

  constructor(
    private _user: UserService,
    private _router: Router
  ) { }

  ngAfterViewInit() {
    $('body').trigger('header-loaded');
  }

  ngOnInit() {
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
      }
    });

    if (process.env.ENV === 'build') {
      this.serviceRid = 'E6C12156-BA1D-4C2F-BA7A-A8F100D24441';
      this.serviceLogin = 'https://login.wmtransfer.com';
    } else {
      this.serviceRid = '6BB2887D-42C0-4840-BFAD-A8C600B165F9';
      this.serviceLogin = 'https://login.wmtransfer.com/better';
    }

    this.currentUser = this._user.currentUser;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/user-block.component.ts